import { IState } from 'core/types';

export const getAppInitialized = ({ init: { appInitialized } }: IState) => appInitialized;
